import { faFacebookF } from "@fortawesome/free-brands-svg-icons/faFacebookF";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";
import React, { FC } from "react";

export const Facebook: FC<
  JSX.IntrinsicAttributes & Omit<FontAwesomeIconProps, "icon">
> = (props) => {
  return <FontAwesomeIcon icon={faFacebookF} {...props} />;
};
